export const GET_PROPERTIES = "GET_PROPERTIES";
export const GET_PROPERTIES_SUCCESS = "GET_PROPERTIES_SUCCESS";
export const GET_PROPERTIES_FAIL = "GET_PROPERTIES_FAIL";

export const ADD_NEW_PROPERTY = "ADD_NEW_PROPERTY";
export const ADD_PROPERTY_SUCCESS = "ADD_PROPERTY_SUCCESS";
export const ADD_PROPERTY_FAIL = "ADD_PROPERTY_FAIL";

export const UPDATE_PROPERTY = "UPDATE_PROPERTY";
export const UPDATE_PROPERTY_SUCCESS = "UPDATE_PROPERTY_SUCCESS";
export const UPDATE_PROPERTY_FAIL = "UPDATE_PROPERTY_FAIL";

export const DELETE_PROPERTY = "DELETE_PROPERTY";
export const DELETE_PROPERTY_SUCCESS = "DELETE_PROPERTY_SUCCESS";
export const DELETE_PROPERTY_FAIL = "DELETE_PROPERTY_FAIL";

export const DELETE_IMAGE_PROPERTY_IN_CLOUD = "DELETE_IMAGE_PROPERTY_IN_CLOUD";

export const MODAL_PROPERTY_SHOW = "MODAL_PROPERTY_SHOW";

export const PROPERTY_SAVED = "PROPERTY_SAVED";
export const SET_PROPERTY = "SET_PROPERTY";

export const UPLOAD_IMAGES_PROPERTY = "UPLOAD_IMAGES_PROPERTY";
export const UPLOAD_IMAGES_PROPERTY_SUCCESS = "UPLOAD_IMAGES_PROPERTY_SUCCESS";

export const GET_PROPERTY_QR = "GET_PROPERTY_QR";
export const SET_PROPERTY_QR = "SET_PROPERTY_QR";
export const GET_PROPERTY_GET_QR_SUCCESS = "GET_PROPERTY_GET_QR_SUCCESS";
export const GET_PROPERTY_RECEIPT = "GET_PROPERTY_RECEIPT";

export const MODAL_PROPERTY_DELETE_SHOW = "MODAL_PROPERTY_DELETE_SHOW";

export const getProperties = (filter) => ({
    type: GET_PROPERTIES,
    payload: filter
  });

export const getPropertyQr = property => ({
    type: GET_PROPERTY_QR,
    payload: property,
  });

  export const getPropertyReceipt = property => ({
    type: GET_PROPERTY_RECEIPT,
    payload: property,
  });
  
  export const getPropertiesSuccess = properties => ({
    type: GET_PROPERTIES_SUCCESS,
    payload: properties,
  });
  
  export const getPropertiesFail = error => ({
    type: GET_PROPERTIES_FAIL,
    payload: error,
  });
  
  export const addNewProperty = property => ({
    type: ADD_NEW_PROPERTY,
    payload: property,
  });
  
  export const addPropertySuccess = property => ({
    type: ADD_PROPERTY_SUCCESS,
    payload: property,
  });
  
  export const addPropertyFail = error => ({
    type: ADD_PROPERTY_FAIL,
    payload: error,
  });
  
  export const updateProperty = property => ({
    type: UPDATE_PROPERTY,
    payload: property,
  });
  
  export const updatePropertySuccess = property => ({
    type: UPDATE_PROPERTY_SUCCESS,
    payload: property,
  });
  
  export const updatePropertyFail = error => ({
    type: UPDATE_PROPERTY_FAIL,
    payload: error,
  });
  
  export const deleteProperty = property => ({
    type: DELETE_PROPERTY,
    payload: property,
  });
  
  export const deletePropertySuccess = property => ({
    type: DELETE_PROPERTY_SUCCESS,
    payload: property,
  });
  
  export const deletePropertyFail = error => ({
    type: DELETE_PROPERTY_FAIL,
    payload: error,
  });

  export const modalPropertyShow = flag => ({
    type: MODAL_PROPERTY_SHOW,
    payload:flag,
  })

  export const setPropertySaved = flag => ({
    type: PROPERTY_SAVED,
    payload: flag,
  })

    export const setProperty = property => ({
    type: SET_PROPERTY,
    payload: property,
  })

  export const uploadImageProperty = data => ({
    type: UPLOAD_IMAGES_PROPERTY,
    payload:data
  })

  export const deleteImagePropertyInCloud = pic => ({
    type: DELETE_IMAGE_PROPERTY_IN_CLOUD,
    payload:pic
  })
  
  export const setUploadImageSuccess = data => ({
    type: UPLOAD_IMAGES_PROPERTY_SUCCESS,
    payload:data
  })

  export const setPropertyQr = data => ({
    type: SET_PROPERTY_QR,
    payload:data
  })

export const getPropertyGetQrSuccess = flag => ({
    type: GET_PROPERTY_GET_QR_SUCCESS,
    payload:flag
})

export const setShowModalPropertyDelete = flag => ({
    type: MODAL_PROPERTY_DELETE_SHOW,
    payload:flag
})